import {Injectable, inject} from '@angular/core';
import {LobService} from '../../services/domain/reference-data/lob/lob.service';

@Injectable({
  providedIn: 'root',
})
export class LobsResolver {

  private lobService = inject(LobService);

  resolve(): Promise<void> {
    return this.lobService.getAllLobs();
  }

}
